/**
 * IbPieCharts class for creating pie charts using D3 and NVD3.
 * @class
 * @param {Object} $window - The window object, typically injected by Angular.
 */
export class IbPieCharts {
    /**
     * Constructor for IbPieCharts class.
     * @param {Object} $window - The window object, typically injected by Angular.
     */
    constructor($window) {
        this.$window = $window;
        this.restrict = 'E'; // Restrict directive to element usage
        this.scope = {
            chartData: '=data', // Bind chart data to the directive
            title: '=title', // Bind title to the directive
            loadPie: '=loadPie' // Bind loadPie flag to the directive
        };
        this.link = this.link.bind(this); // Bind the link method to the instance
    }

    /**
     * Link function to set up watchers and initialize the chart.
     * @param {Object} scope - The Angular scope object.
     * @param {Object} element - The DOM element the directive is applied to.
     */
    link(scope, element) {
        // Watch for changes in chartData and re-initialize the chart
        scope.$watch('chartData', () => this.init(scope, element));
        // Watch for changes in title and re-initialize the chart
        scope.$watch('title', () => this.init(scope, element));
        // Watch for changes in loadPie and re-initialize the chart
        scope.$watch('loadPie', () => this.init(scope, element));
    }

    /**
     * Initialize the pie chart.
     * @param {Object} scope - The Angular scope object.
     * @param {Object} element - The DOM element the directive is applied to.
     */
    init(scope, element) {
        // Check if chartData is defined, has at least one element, and loadPie is true
        if (typeof(scope.chartData) !== 'undefined' && scope.chartData.length >= 1 && scope.loadPie) {
            // Calculate the width of the chart container
            var w = Math.max(this.$window.jQuery(element[0]).parent().parent().width() - 15, 350),
                css = 'width:' + w + 'px !important;height:400px !important';

            var svg = element.find('svg')[0]; // Find the SVG element within the directive

            // Create a new pie chart using NVD3
            var chart = this.$window.nv.models.pieChart()
                .x(function(d) { return d.label }) // Set the x accessor to the label
                .y(function(d) { return d.value }) // Set the y accessor to the value
                .showLabels(true) // Show labels on the chart
                .labelType("percent") // Set label type to percent
                .color(["#1f77b4", "#B10DC9", "#2ca02c", "#d62728", "#9467bd", "#8c564b", "#e377c2", "#7f7f7f", "#bcbd22", "#17becf"]); // Set chart colors

            // Select the SVG element and bind the chart data
            this.$window.d3.select(svg)
                .attr('style', css) // Apply the calculated CSS
                .datum(scope.chartData) // Bind the chart data
                .transition().duration(350) // Apply a transition
                .call(chart); // Render the chart

            // Handle window resize events to update the chart
            this.$window.nv.utils.windowResize(chart.update);

            return chart; // Return the chart object
        }
    }
}

/**
 * Register the IbPieCharts directive with the given module.
 * @param {Object} module - The Angular module to register the directive with.
 */
export default function registerIbPieChartsDirective(module) {
    module.directive('ibPieCharts', ['$window', function($window) {
        return new IbPieCharts($window);
    }]);
}